/**
 * The search field of a view's filter bar (in a ViewHeader's actions, beside at most two choices):
 * a magnifier, the words, and a clear button, at the width of the other controls. `onChange` gets
 * every keystroke; a caller that asks the server debounces it.
 */

import { SearchField } from '@heroui/react';

export function SearchBox({ label, value, onChange, placeholder, className }: { label: string; value: string; onChange: (v: string) => void; placeholder?: string; className?: string }) {
  return (
    <SearchField aria-label={label} variant="secondary" value={value} onChange={onChange} className={className ?? 'w-56 max-w-full'}>
      <SearchField.Group>
        <SearchField.SearchIcon />
        <SearchField.Input className="min-w-0" placeholder={placeholder ?? 'Search…'} />
        <SearchField.ClearButton />
      </SearchField.Group>
    </SearchField>
  );
}
